export interface KnowledgeCitation {
  sourceId: string;
  chunkId: string;
  version: number;
  documentETag: string;
  locatorJson: string;
  name: string;
  url: string;
}

export function KnowledgeCitations({ citations }: { citations?: KnowledgeCitation[] }) {
  if (!citations?.length) return null;
  return <aside aria-label="Document sources" className="mt-3 border-t pt-2 text-xs">
    <p className="font-medium mb-1">Document sources</p>
    <ol className="space-y-1">
      {citations.map((citation, index) => {
        let location = "Verified passage";
        try {
          const locator = JSON.parse(citation.locatorJson);
          const positive = (value: unknown): value is number =>
            typeof value === "number" && Number.isSafeInteger(value) && value > 0;
          if (locator.kind === "nested-table-row" && positive(locator.table) &&
            positive(locator.nestedRow) && Array.isArray(locator.parents) &&
            locator.parents.length > 0 && locator.parents.length <= 2 &&
            locator.parents.every((p: { row?: unknown; column?: unknown; nestedTable?: unknown }) =>
              positive(p.row) && positive(p.column) && positive(p.nestedTable))) {
            location = `Table ${locator.table}, ` + locator.parents.map(
              (p: { row: number; column: number; nestedTable: number }) =>
                `row ${p.row}, column ${p.column}, nested table ${p.nestedTable}`
            ).join(", ") + `, row ${locator.nestedRow}`;
          } else if (locator.kind === "table-row" && positive(locator.table) && positive(locator.row)) {
            location = `Table ${locator.table}, row ${locator.row}`;
          } else if (locator.kind === "paragraph" && positive(locator.paragraph)) {
            location = `Paragraph ${locator.paragraph}`;
          }
        } catch { /* Never render malformed location JSON as markup. */ }
        let safeUrl: string | undefined;
        try {
          const url = new URL(citation.url);
          if (url.protocol === "https:" && url.hostname.endsWith(".sharepoint.com") &&
            !url.username && !url.password && !url.search) safeUrl = url.href;
        } catch { /* Untrusted links remain plain text. */ }
        return <li key={citation.chunkId || index}>
          {safeUrl
            ? <a href={safeUrl} target="_blank" rel="noopener noreferrer" className="underline">
              {citation.name}
            </a> : citation.name}
          {" — "}{location}, reviewed version {citation.version}
        </li>;
      })}
    </ol>
  </aside>;
}